import { Box, Divider } from '@mui/material';
import MenuBarSearch    from 'components/table/page/MenuBarSearch'
import MenuBarPaging    from 'components/table/page/MenuBarPaging'
import MenuBarReload    from 'components/table/page/MenuBarReload';
import { ToolbarFunctions, useToolbar } from 'contexts/ToolbarContext';
import { SetState } from 'types/react';
import { FilterProps, SearchOptions, Status } from '../LargeTable';
import { ReactElement } from 'react';

type MenuBarProps = {
  showToolbar: boolean;
  disableReload: boolean;
  filterProps?: FilterProps

  pageable: boolean;
  status: Status;

  extraMenuItems: (toolbarFunctions: ToolbarFunctions) => ReactElement[];
  lazySearch: boolean;
};

const MenuBar = ({showToolbar, disableReload, filterProps, pageable, status, extraMenuItems, lazySearch} : MenuBarProps) => {
  const toolbarFunctions = useToolbar()

  if (showToolbar) {
    return (
      <Box style={{flexShrink: 0}}>
        <Box style={{display: "flex", flexFlow: 'row nowrap', maxWidth: "100%", overflow: "auto", alignItems: "center" }}>
          
          {filterProps && <MenuBarSearch
            onChange={toolbarFunctions.filter}
            loading={status.busy && status.with === 'filter'}
            filter={filterProps.filter}
            setFilter={filterProps.setFilter}
            lazy={lazySearch}
          />}
          <Box style={{flexGrow:1}} />
          <MenuBarPaging
            pageable={pageable}
            toolbarFunctions={toolbarFunctions}
            status={status}
          />
          <MenuBarReload
            disableReload={disableReload}
            onClick={toolbarFunctions.reload}
            loading={status.busy && status.with === 'reload'}
          />
          {extraMenuItems(toolbarFunctions)}
        </Box>
        <Divider/>
      </Box>
    )
  } else return null
}

export default MenuBar
